import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "dbm:announcement-dismissed";

/**
 * Temporary site-wide announcement. Copy, link and on/off live in
 * /admin/announcement — saving new copy bumps the version so previous
 * dismissals reset.
 */
export default function AnnouncementBar() {
  const [ann, setAnn] = useState(null);
  const [dismissedVersion, setDismissedVersion] = useState(null);

  useEffect(() => {
    try {
      setDismissedVersion(localStorage.getItem(KEY));
    } catch (err) {
      setDismissedVersion(null);
    }
    let alive = true;
    axios
      .get(`${API}/announcement`)
      .then(({ data }) => {
        if (alive) setAnn(data);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!ann || !ann.enabled || !ann.text) return null;
  if (dismissedVersion && String(ann.version) === dismissedVersion) return null;

  const dismiss = () => {
    setDismissedVersion(String(ann.version));
    try {
      localStorage.setItem(KEY, String(ann.version));
    } catch (err) {
      /* private mode — the bar comes back next visit */
    }
  };

  const external = /^https?:\/\//i.test(ann.url);
  const linkClass =
    "block max-w-[1200px] mx-auto px-10 sm:px-12 py-2.5 text-center text-[11px] sm:text-xs uppercase transition-opacity hover:opacity-80";
  const linkStyle = { letterSpacing: "0.14em", fontWeight: 700, lineHeight: 1.5 };
  const label = (
    <>
      {ann.text} <span aria-hidden="true">&rarr;</span>
    </>
  );

  return (
    <div
      className="relative w-full"
      style={{ backgroundColor: "#F2D589", color: "#080419", zIndex: 40 }}
      data-testid="announcement-bar"
    >
      {external ? (
        <a
          href={ann.url}
          target="_blank"
          rel="noreferrer"
          data-testid="announcement-link"
          className={linkClass}
          style={linkStyle}
        >
          {label}
        </a>
      ) : (
        <Link to={ann.url} data-testid="announcement-link" className={linkClass} style={linkStyle}>
          {label}
        </Link>
      )}
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss announcement"
        data-testid="announcement-dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex items-center justify-center h-7 w-7 rounded-full text-base leading-none transition-colors hover:bg-black/10"
        style={{ color: "#080419" }}
      >
        ×
      </button>
    </div>
  );
}
